export default {
    inserted: el => {
        function loadImage() {
            const imageElements = Array.from(el.children).filter(
                el => el.nodeName === "IMG" || el.nodeName === "SOURCE"
            );
            if (imageElements.length > 0)imageElements.forEach(function(imageElement) {
                imageElement.addEventListener("load", () => {
                    setTimeout(() => el.classList.add("loaded"), 100);
                });
                imageElement.addEventListener("error", () => console.log("error"));
                if(imageElement.dataset.src)imageElement.src = imageElement.dataset.src;
                if(imageElement.dataset.srcset)imageElement.srcset = imageElement.dataset.srcset;
            });
        }

        function handleIntersect(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadImage();
                    observer.unobserve(el);
                }
            });
        }

        function createObserver() {
            const options = {
                root: null,
                threshold: "0"
            };
            const observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(el);
        }

        if (window["IntersectionObserver"]) {
            createObserver();
        } else {
            loadImage();
        }
    }
};